// src/App.tsx
import React from 'react';
import AppRouterProvider from './router';

function App() {
  return <AppRouterProvider />;
}

export default App;
